import { useIntl } from "react-intl";

const MultipleIdP = () => {
    const intl = useIntl();

    const messages = {
        title: intl.formatMessage({
            id: "jira-software-pricing.modal-content.multiple-idp.title",
            defaultMessage: "Multiple identity providers"
        }),
        body1: intl.formatMessage({
            id: "jira-software-pricing.modal-content.multiple-idp.body1",
            defaultMessage:
                "Support multiple identity providers for a single organization."
        }),
        body2: intl.formatMessage({
            id: "jira-software-pricing.modal-content.multiple-idp.body2",
            defaultMessage:
                "Customers can now connect multiple identity providers to implement SAML SSO and SCIM user provisioning to their Atlassian Cloud organization."
        })
    };

    return (
        <div>
            <h2>{messages.title}</h2>
            <p>{messages.body1}</p>
            <p>{messages.body2}</p>
        </div>
    );
};

export default MultipleIdP;
